export const borderRadius = 100;
export const tabHeight = 36;
